import React from 'react'
import { ModalBody, Label, Input } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'

const VALIDITY = {
  MONTH: '31',
  HALF_YEAR: '183',
  YEAR: '366',
  UNLIMITED: '0'
}

const InputPatTokenNameDialog = (props) => {
  const [name, setName] = React.useState('')
  const [validityInDays, setValidityInDays] = React.useState(VALIDITY.YEAR)

  const renderValidityOption = (days) => {
    const key = `Security.Validity${days}Days`
    return (
      <option key={key} value={days}>{props.localize(key)}</option>
    )
  }
  return (
    <ValidationBoundary>
      <BasicHeader title='Security.EnterTokenName' {...props} />
      <ModalBody>
        <ErrorBoundary>
          <Label>{props.localize('Security.Validity')}</Label>
          <select id='validity' value={validityInDays} onChange={(e) => setValidityInDays(e.target.value)} className='form-control validity-select'>
            {Object.keys(VALIDITY).map(key => renderValidityOption(VALIDITY[key]))}
          </select>
          <Label>{props.localize('Common.Name')}</Label>
          <Validator name='name' value={name} required>
            <Input id='name' onChange={(e) => setName(e.target.value)} value={name} />
          </Validator>
        </ErrorBoundary>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter primaryButtonText='Security.Generate' icon='save' {...props} onAction={() => props.onAction({ name, validityInDays })} disabled={!isValid} />
      } />
    </ValidationBoundary>
  )
}

export default {
  component: InputPatTokenNameDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/inputPatTokenName.js